/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Scope_Section_EmptyInputs */



/**
* | output |
* | --- |
* | "Nothing to pick here yet." |
*
* @param {Agent_Scope_Section_EmptyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_scope_section_empty = /** @type {((inputs?: Agent_Scope_Section_EmptyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Scope_Section_EmptyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Hier gibt es noch nichts auszuwählen.")
	return /** @type {LocalizedString} */ ("Nothing to pick here yet.")
});